import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { RestService } from '../rest.service';

@Component({
  selector: 'app-arqueapp',
  templateUrl: './arqueapp.component.html',
  styleUrls: ['./arqueapp.component.scss']
})
export class ArqueappComponent implements OnInit {

  list_js: any[] = [];
  list_emp: any[] = [];

  centros: any[] = [];
  maquinas: any[] = [];

  centro_id = 1;
  maquina_id = 1;

  valor;

  constructor(public rest: RestService) { }

  ngOnInit() {
    this.getJS();
    this.getEMP();
    this.getCentros();
  }

  getJS() {
    this.rest.getPagosJS().subscribe((data) => {
      this.list_js = data['data'];
    });
  }

  getEMP() {
    this.rest.getPagosEmp().subscribe((data) => {
      this.list_emp = data['data'];
    });
  }

  getCentros() {
    this.rest.getCentros().subscribe((data) => {
      this.centros = data['data'];
    });
  }

  getMaquinas() {
    this.rest.getMaquinaXCentro(this.centro_id).subscribe((data) => {
      this.maquinas = data['data'];
    });
  }

  postPagos() {
    this.rest.postPagosJS(this.valor, this.maquina_id).subscribe((data) => {
      console.log(data);
      this.getJS();
      this.valor = null;
    });
  }

}
